import React from "react";
// import { styled } from "@linaria/react"
// import { useStore } from "effector-react"
// import { backRoutePanel } from "../../../common/config/vars"

interface INewsNotFound {
  text: string | JSX.Element;
}

export const NewsNotFound = ({ text }: INewsNotFound) => {
  return (
    <div className="page__data-card">
      <p className="data-card__text">{text}</p>
    </div>
  );
};
